import React from "react"
import ReactMarkdown from "react-markdown"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

// Components
import "./style.css"
import HalfLeftChurchIcon from "./../../images/HalfLeftChurchIcon"
import HalfRightChurchIcon from "./../../images/HalfRightChurchIcon"

// Nyhetsboks på forsiden
const ShowCaseBox = ({ image, title, text, to }) => {
    return (
        <div className={`news-box ${!image && "news-box--text-only church-theme-box church-theme-box--green"}`}>
            { !image && <HalfLeftChurchIcon color="#C8D200" /> }
            { !image && <HalfRightChurchIcon color="#C8D200" /> }

            { image && <div className="news-box-image">
                <img className="img-res" src={image} alt={title} />
            </div> }
            <div className="news-box-text">
                <div className={`news-box-text-inner ${!image && "church-theme-box__inner"}`}>
                    <h2>{ title }</h2>
                    <ReactMarkdown source={text || ""} />
                    { to && <Link to={to} className="button button--large button--green">Les mer</Link>}
                </div>
            </div>
        </div>
    )
}

export default ShowCaseBox

ShowCaseBox.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    to: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/ShowCaseBox/index.js